interface TimestampColumn {
  timestamp: string;
  timestampMs: number;
}

/**
 * Finds the timestamp that contains the current time based on the grouping interval
 * @param timestampColumns Array of timestamp columns with their millisecond values
 * @param groupInterval The interval in hours ('1', '3', '6', '12', '24')
 * @returns The timestamp in milliseconds that contains the current time, or null if not found
 */
export const findCurrentPeriodTimestamp = (
  timestampColumns: TimestampColumn[],
  groupInterval: string
): number | null => {
  if (!timestampColumns.length) return null;
  const now = Date.now();
  const intervalHours = parseInt(groupInterval);
  
  // Special handling for 24-hour grouping to align with calendar days
  if (intervalHours === 24) {
    const nowDate = new Date(now);
    // Start of current day in UTC to match timestamps
    const todayStart = Date.UTC(
      nowDate.getUTCFullYear(),
      nowDate.getUTCMonth(),
      nowDate.getUTCDate()
    );
    
    // Find the timestamp for today
    for (let i = timestampColumns.length - 1; i >= 0; i--) {
      const colDate = new Date(timestampColumns[i].timestampMs);
      const colDayStart = Date.UTC(
        colDate.getUTCFullYear(),
        colDate.getUTCMonth(),
        colDate.getUTCDate()
      );
      
      if (todayStart === colDayStart) {
        return timestampColumns[i].timestampMs;
      }
    }
  } else {
    // For other intervals, find the period that contains the current time
    for (let i = timestampColumns.length - 1; i >= 0; i--) {
      const periodEnd = timestampColumns[i].timestampMs;
      const periodStart = periodEnd - (intervalHours * 60 * 60 * 1000);
      
      if (now >= periodStart && now <= periodEnd) {
        return timestampColumns[i].timestampMs;
      }
    }
  }
  
  return null;
};
